module.exports = __webpack_public_path__ + "resources/img/solution_commerce_rescue4_m_v2.0f636dd7908ad3d91600745327dbf452.png";